<template>
  <section class="bg-white flex flex-col-reverse xl:flex-row px-6 md:px-10 py-10 md:py-12 xl:py-0 relative items-center antialiased">
  
  <!-- Bagian Form -->
  <div class="w-full xl:w-1/2 flex justify-center xl:justify-start py-10 lg:pr-10 md:pr-0 pr-0 lg:px-8 max-w-full">
    <div class="w-full transform transition-all duration-300 xl:order-1">
      <div class="flex items-center justify-start mb-6">
        <div class="h-7 w-1 bg-[#186a85] rounded-lg"></div>
        <span class="px-3 py-1 text-[#186a85] text-md font-medium tracking-wider">Get In Touch</span>
      </div>
      <h2 class="text-3xl font-semibold text-[#186a85] mb-2">Say Hi to the team</h2>
      <div class="w-16 h-1 bg-[#b8e9f2] mt-2 mb-6"></div>
      <p class="text-gray-500 mb-6 text-md xl:text-lg">
        Whether you have questions, ideas, or feedback, we're here to listen and collaborate. Simply fill out the form below, and we'll get back to you promptly.
      </p>
      <form @submit.prevent="sendEmail" class="space-y-5 w-full">
        <div class="relative">
          <input
            v-model="form.name"
            type="text"
            placeholder="Your Name"
            class="w-full p-4 pl-12 border border-gray-300 rounded-xl placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#186a85] focus:border-transparent" />
          <span class="absolute left-3 top-4 text-[#186a85]">
            <i class="fas fa-user"></i>
          </span>
        </div>
        <div class="relative">
          <input
            v-model="form.email"
            type="email"
            placeholder="Email Address"
            class="w-full p-4 pl-12 border border-gray-300 rounded-xl placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#186a85] focus:border-transparent" />
          <span class="absolute left-3 top-4 text-[#186a85]">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <div class="relative">
          <textarea
            v-model="form.message"
            placeholder="Message"
            class="w-full p-4 pl-12 border border-gray-300 rounded-xl placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#186a85] focus:border-transparent h-32 resize-none"></textarea>
          <span class="absolute left-3 top-4 text-[#186a85]">
            <i class="fas fa-comment-alt"></i>
          </span>
        </div>
        <div>
          <button 
            type="submit"
            @click="console.log('Tombol diklik')"
            class="px-6 py-3 bg-[#186a85] text-white rounded-full hover:bg-[#14576c] transition-all duration-200">
            send message
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Bagian Gambar -->
  <div class="flex w-full xl:w-1/2 justify-center items-center xl:order-2">
    <img src="@/assets/contact.svg" alt="Welcome Image" class="h-auto max-w-full">
  </div>
</section>

<!-- Map Section with Enhanced Design -->
<section class="w-screen h-screen antialiased">
    <div class="text-center mb-12">
        <span class="bg-[#e6f7fa] text-[#186a85] px-4 py-1 rounded-full text-sm font-medium inline-block mb-4">Lokasi Kami</span>
        <h2 class="text-3xl md:text-4xl font-bold text-center relative inline-block">
          <span class="relative">
            Kunjungi Kantor Kami
            <span class="absolute -bottom-2 left-0 w-full h-1 bg-[#b8e9f2] opacity-50"></span>
          </span>
        </h2>
        <p class="text-gray-600 max-w-2xl mx-auto mt-4 text-lg">
          Temukan lokasi kami yang strategis di Jakarta Utara. Kami siap menyambut Anda!
        </p>
      </div>
    <div class="w-full h-full overflow-hidden">
      <iframe
        class="w-full h-full"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.208682575002!2d106.7401227!3d-6.102575700000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a1d241e007f0d%3A0x7bf18422ba371c19!2sGold%20Coast%20Office!5e0!3m2!1sid!2sid!4v1744441165320!5m2!1sid!2sid"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>
</section>
  </template>
<script>
import axios from 'axios';

export default {
  name: "ContactPage",
  data() {
    return {
      mapUrl: "https://maps.app.goo.gl/4UbgbSqe4TKLAPEK8=YOUR_GOOGLE_MAPS_API_KEY",
      form: {
        name: "",
        email: "",
        message: "",
      }
    };
  },
  methods: {
    sendEmail() {
      console.log("Form submitted!"); // Debugging log
      
      // Validasi dasar
      if (!this.form.name || !this.form.email || !this.form.message) {
        alert("Please complete all fields");
        return;
      }
      
      axios.post("http://localhost:8000/send-email.php", this.form)
        .then(response => {
          console.log("Respon dari server:", response.data);
          if (response.data.success) {
            alert("Message Delivered!");
            // Reset form setelah berhasil
            this.form.name = "";
            this.form.email = "";
            this.form.message = "";
          } else {
            alert("Failed to send message: " + (response.data.message || ""));
          }
        })
        .catch(error => {
          console.error("Error occurred:", error);
          alert("An error occurred while sending the message");
        });
    }
  }
};
</script>
  
  